export const URL = '/v2/pms/accomodations/:accomId/media/batch_delete/'

export type Req = {
  ids: number[]
}

export type Resp = any